import http from '@root/utils/axios/admin';

let state = {
    GameStoriesList: [],
    GameStory: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchGameStoriesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/game-stories', { params: filter }).then((response) => {
                commit('setGameStoriesList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    fetchGameStory({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/game-stories/' + id).then((response) => {
                commit('setGameStory', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },



}


let mutations = {
    setGameStoriesList(state, data) {
        state.GameStoriesList = data;
    },
    setGameStory(state, data) {
        state.GameStory.data = data;
    },
}

export default {
    state,
    actions,
    mutations
}